<template>
  <div class="Maincontent"
       :class="collapse?'position-collapse-left':'position-left'">
    <el-dialog title="选择园区"
               :visible="dropdownTissue"
               width="880px"
               custom-class="tissue-merchant-select-dialog"
               append-to-body
               @close="closeTissueSelectDialog">
      <!-- 园区列表过滤-->
      <Boyo-Filter ref="tissueFilter"
                   :filter="tissueFilterInfo"
                   :listTypeInfo="{}"
                   :result="tissueFilterResult"
                   @handleClick="handleTissueFilter">
      </Boyo-Filter>
      <el-table :data="filteredTissueList"
                v-loading="tissueListLoading"
                border
                stripe
                highlight-current-row
                max-height="440"
                class="tissue-select-table"
                @row-click="switchTissue">
        <el-table-column min-width="200"
                         show-overflow-tooltip>
          <template slot="header">
            <span>园区名称</span>
          </template>
          <template slot-scope="scope">
            {{ scope.row.tissueName || scope.row.name || '—' }}
          </template>
        </el-table-column>
        <el-table-column min-width="130"
                         label="编号"
                         show-overflow-tooltip>
          <template slot-scope="scope">
            {{ tissueNumberDisplay(scope.row) }}
          </template>
        </el-table-column>
      </el-table>
      <div slot="footer"
           class="tissue-select-dialog-footer">
        <el-button @click="closeTissueSelectDialog">取消</el-button>
      </div>
    </el-dialog>
    <div class="dropdown-menu"
         id="dropdown-menu"
         v-show="dropdownMenu">
      <ul>
        <li>
          <div class="li-item"
               @click="geren()">
            <span class="iconfont icongeren"
                  style="font-size:14px">&nbsp;&nbsp;个人中心</span>
          </div>
        </li>
        <li>
          <div class="li-item"
               @click="dialog('PswDialog')">
            <span class="iconfont iconmima"
                  style="font-size:14px">&nbsp;&nbsp;修改密码</span>
          </div>
        </li>
        <!-- <li>
          <div class="li-item"
               @click="dialog('TissueDialog')">
            <span class="iconfont iconbumen"
                  style="font-size:14px">&nbsp;&nbsp;组织切换</span>
          </div>
        </li> -->
        <!-- <li>
          <div class="li-item"
               @click="dialog('ColorDialog')">
            <span class="iconfont iconjingzi"
                  style="font-size:14px">&nbsp;&nbsp;切换主题</span>
          </div>
        </li> -->
        <li class="divider"></li>
        <li>
          <!-- 注销 -->
          <div class="li-item"
               @click="loding?'':zhuxiao()">
            <span class="iconfont iconzhuxiao"
                  style="font-size:14px">&nbsp;&nbsp;退出登录</span>
          </div>
        </li>
      </ul>
    </div>
    <!-- 对话框组件 -->
    <Boyo-Dialog :dialogInfo="PswDialog"
                 @dialogEvent="pswEvent">
      <div class="psw-password-dialog-slot">
      <div v-if="PswDialog.lockClose" class="force-password-tip">
        当前账号仍为初始密码，请先完成修改后继续使用系统
      </div>
      <Boyo-Form :formInfo="PswInfo"
                 :refObj.sync="PswInfo.ref">
      </Boyo-Form>
      <div class="password-policy-panel">
        <div
          v-for="row in passwordPolicyRuleList"
          :key="row.key"
          class="password-policy-row"
          :class="'status-' + row.status"
        >
          <i
            v-if="row.status === 'ok'"
            class="el-icon-circle-check password-policy-icon password-policy-icon--ok"
          ></i>
          <i
            v-else-if="row.status === 'fail'"
            class="el-icon-warning-outline password-policy-icon password-policy-icon--fail"
          ></i>
          <span
            v-else
            class="password-policy-dot"
          ></span>
          <span class="password-policy-text">{{ row.text }}</span>
        </div>
      </div>
      <div class="password-strength-panel">
        <span class="label">密码强度：</span>
        <div class="strength-content">
          <div class="strength-bar">
            <span
              class="strength-fill"
              :class="passwordStrengthInfo.className"
              :style="{ width: passwordStrengthInfo.percent + '%' }"
            ></span>
          </div>
          <span class="strength-text" :class="passwordStrengthInfo.className">{{ passwordStrengthInfo.text }}</span>
        </div>
      </div>
      <div class="password-strength-tip">
        {{ passwordStrengthTip }}
      </div>
      </div>
    </Boyo-Dialog>
    <Boyo-Dialog :dialogInfo="TissueDialog"
                 @dialogEvent="TissueEvent">
      <Boyo-Form :formInfo="TissueInfo"
                 :refObj.sync="TissueInfo.ref"
                  :listTypeInfo="listTypeInfo">
      </Boyo-Form>
    </Boyo-Dialog>
    <Boyo-Dialog :dialogInfo="ColorDialog"
                 class="ThemeColor">
      <ul>
        <li v-for="(item,index) of ColorList"
            :key="index"
            class="color_item">
          <div class="ThemeItem"
               @click="changeColor(item)">
            <span style="width: 20%; float: left; height: 13px; background: #367fa9"
                  :style="item.style1"></span>
            <span style="width: 80%; float: left; height: 13px; "
                  :style="item.style2"></span>
            <span style="width: 20%; float: left; height: 30px;"
                  :style="item.style3"></span>
            <span style="width: 80%; float: left; height: 30px;"
                  :style="item.style4"></span>
            <span style="display:block; width: 100%;height:0px;overflow:hidden"></span>
          </div>
          <span style="display:block;width:100%;text-align:center">{{item.desc}}</span>
        </li>
        <li style="clear:both;height:0;padding:0"></li>
      </ul>
    </Boyo-Dialog>
    <div class="Maincontent-content"
         :style="{ bottom: isHomeRoute ? '36px' : '0' }">
      <!-- <keep-alive :include="includeList">
        <router-view v-if="$route.meta.keepalive"></router-view>
      </keep-alive>
      <router-view v-if="!$route.meta.keepalive"></router-view> -->
      <router-view v-if="$route.meta.keepalive"></router-view>
      <!-- ReportUpdate,ReportDetail,ReportsViewList报表设计修改和明细/CusInformation往来单位信息详细/AppointmentApproval预约审批/AppointmentStart预约入厂/PurchaseOrderForm采购订单/ScrapSteelQuotation采购合同/ScrapSteelQuotationApproval合同部门审批/PurchaseOrder产品报价单/DeliveryNote采购送货单/SalesOrderList销售订单/ShippingNotice发货通知单/BillofLading销售提货单/CarEnter车辆入厂 -->
      <!-- <keep-alive exclude="ReportUpdate,ReportDetail,ReportsViewList,CusInformation,NowEvaluation,AppointmentApproval,AppointmentPrint,AppointmentStart,PurchaseOrderForm,ScrapSteelQuotation,ScrapSteelQuotationApproval,ContractApproval,PurchaseOrder,PurchaseOrderApproval,SalesOrderReview,DeliveryNote,SalesOrderList,ShippingNotice,ShippingPriceApproval,SalesOrderListLimit,BillofLading,CarEnter,WeightDifferenceApproval,WeighOne,WeighTwo,CarLeaving,SalesList,SalesListOperation,DeliveryNoticeOperation,ShipWeighingList,Mailbox,LargeScreenList,AddEvaluation,SaveBasePrice,NowBasePrice,Weighing,StockCounting,BendingProduction,HangerChange,StockCountingQuantityRecord,StkOutProductPage,CollectionOrderList,PaymentReceiptInvoice">
        <router-view v-if="$route.meta.keepalive" :typeWebS="typeWebS" :language="language"></router-view>
      </keep-alive> -->
    </div>
    <!-- <div class="foot">© 2023 BoYo Copyright 福州博亚电子科技有限公司 客服电话：0591-83508810，15395905222  </div> -->
    <div v-if="isHomeRoute"
         class="foot">
      <span>博亚奇乐云 ylpiao.cn</span>
      <a
        href="http://beian.miit.gov.cn"
        target="_blank"
        rel="noopener noreferrer"
        class="foot-record-link"
      >
        闽ICP备2022011329号-4
      </a>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import md5 from 'js-md5'
import * as pwdPolicy from '@/utils/passwordStrength'
import BoyoDialog from '@/components/BoyoDialog'
import BoyoForm from '@/components/BoyoForm'
import BoyoFilter from '@/components/BoyoFilter'
import axios from 'axios'
import config from '@/api/config'
export default {
  name: 'MainContent',
  provide: function () {
    return {
      reload: this.reload
    }
  },
  components: {
    BoyoDialog,
    BoyoForm,
    BoyoFilter
  },
  props: {
    typeD:{
      type: String,
      // 定义默认值
      default: '1'
    },
    typeTime:{
      type: String,
      // 定义默认值
      default: ''
    },
  },
  computed: {
    ...mapState({
      collapse: state => state.app.collapse,
      dropdownMenu: state => state.tabs.dropdownMenu,
      dropdownTissue: state => state.tabs.dropdownTissue,
      // TabList: state => state.tabs.TabList,
      // TissueList: state => state.tabs.TissueList
    }),
    isHomeRoute () {
      // 首页：/index 下的默认子路由（path 为空，name 为“首页”）
      return this.$route && (this.$route.path === '/index' || this.$route.name === '首页')
    },
    TabList: {
      get () { return this.$store.state.tabs.TabList },
      set (val) { this.$store.commit('updateTabList', val) }
    },
    // 根据园区过滤条件实时过滤列表
    filteredTissueList () {
      const list = Array.isArray(this.TissueList) ? this.TissueList : []
      const nameKey = this.tissueFilterApplied && this.tissueFilterApplied.tissueName
        ? String(this.tissueFilterApplied.tissueName).trim().toLowerCase()
        : ''
      const idKey = this.tissueFilterApplied && this.tissueFilterApplied.tissueId
        ? String(this.tissueFilterApplied.tissueId).trim()
        : ''
      return list.filter(it => {
        if (!it) return false
        const tissueName = String(it.tissueName || it.name || '').trim().toLowerCase()
        const tissueId = it.id !== undefined && it.id !== null ? String(it.id) : ''
        const okName = !nameKey || tissueName.includes(nameKey)
        const okId = !idKey || tissueId.includes(idKey)
        return okName && okId
      })
    },
    passwordStrengthInfo () {
      const value = (this.PswInfo && this.PswInfo.data && this.PswInfo.data.newPassword) ? this.PswInfo.data.newPassword : ''
      const result = pwdPolicy.evaluatePasswordStrength(value)
      return {
        score: result.score,
        percent: result.percent,
        text: result.text,
        className: result.className
      }
    },
    passwordStrengthTip () {
      const value = (this.PswInfo && this.PswInfo.data && this.PswInfo.data.newPassword) ? this.PswInfo.data.newPassword : ''
      if (!value) {
        return '请按下方规则设置新密码（6～16 位）。'
      }
      const result = pwdPolicy.evaluatePasswordStrength(value)
      return result.tip || '请适当加长并提高复杂度。'
    },
    passwordPolicyRuleList () {
      const pwd = (this.PswInfo && this.PswInfo.data && this.PswInfo.data.newPassword) ? this.PswInfo.data.newPassword : ''
      return pwdPolicy.getPasswordPolicyRuleStates(pwd)
    }
  },
  data () {
    var validateOldPassword = (rule, value, callback) => {
      const skip = this.PswDialog && (this.PswDialog.lockClose || localStorage.needOpenPasswordDialog === '1')
      if (skip) {
        callback()
        return
      }
      if (value === '') {
        callback(new Error('请输入旧密码'))
      } else {
        callback()
      }
    }
    var validateNewPasswordField = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入新密码'))
        return
      }
      if (!pwdPolicy.isPasswordLengthValid(value)) {
        callback(new Error(pwdPolicy.PASSWORD_POLICY_TEXT.length))
        return
      }
      if (!pwdPolicy.isPasswordTwoPlusCharTypes(value)) {
        callback(new Error(pwdPolicy.PASSWORD_POLICY_TEXT.types))
        return
      }
      if (pwdPolicy.hasForbiddenRepeatOrSequence(value)) {
        callback(new Error(pwdPolicy.PASSWORD_POLICY_TEXT.seq))
        return
      }
      if (this.PswInfo.data.surePass !== '') {
        this.$nextTick(() => {
          if (this.PswInfo.ref && this.PswInfo.ref.validateField) {
            this.PswInfo.ref.validateField('surePass')
          }
        })
      }
      callback()
    }
    var validateSurePassField = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'))
      } else if (value !== this.PswInfo.data.newPassword) {
        callback(new Error('两次输入密码不一致'))
      } else {
        callback()
      }
    }
    return {
      // TabList:[],
      // 用于对比 storage 事件里新旧园区，避免重复刷新/误刷新
      currentTissueId: localStorage.loginTissueId,
      typeWebS:'',
      language:'',
      isRou: true,
      loding: false,
      // TissueList:JSON.parse(localStorage.TissueList),
      TissueList:[],
      tissueListLoading: false,
      // 园区切换弹窗过滤
      tissueFilterInfo: {
        visible: true,
        data: {
          tissueName: '',
          tissueId: ''
        },
        list: [
          { type: 'text', label: '园区名称：', value: 'tissueName', style: 'width:180px' },
          { type: 'text', label: '编号：', value: 'tissueId', style: 'width:150px' }
        ]
      },
      tissueFilterResult: {},
      tissueFilterApplied: {},
      listTypeInfo:{
        tissueId:[]
      },
      // 修改密码弹窗
      PswDialog: {
        visible: false, // 弹框是否显示
        width: '700px', // 宽度
        lockClose: false, // 是否禁止关闭（遮罩/ESC/右上角/关闭按钮）
        title: {
          reset: '修改密码'// 标题
        },
        type: 'reset', // 显示哪个标题
        // 按钮列表
        btList: [
          { label: '确定', type: 'primary', icon: '', event: 'save', loading: false },
          { label: '关闭', type: '', icon: '', event: 'close', loading: false },
          { label: '退出登录', type: 'danger', icon: '', event: 'logout', loading: false, show: false }
        ]
      },
      // 修改密码表单
      PswInfo: {
        ref: null,
        labelWidth: '25%',
        data: {
          // id: JSON.parse(localStorage.personal).id,
          // name: JSON.parse(localStorage.personal).username,
          oldPassword: '',
          newPassword: '',
          surePass: ''
        },
        list: [
          // { type: 'text', label: '登录名称：', value: 'name', disabled: true, style: 'width:80%' },
          { type: 'password', label: '旧密码：', value: 'oldPassword', style: 'width:80%', shows: true, show: true },
          { type: 'password', label: '新密码：', value: 'newPassword', style: 'width:80%' },
          { type: 'password', label: '确认密码：', value: 'surePass', style: 'width:80%' }
        ],
        rules: {
          oldPassword: [{ validator: validateOldPassword, trigger: 'blur' }],
          newPassword: [{ required: true, validator: validateNewPasswordField, trigger: 'blur' }],
          surePass: [{ required: true, validator: validateSurePassField, trigger: 'blur' }]
        }
      },
      // 组织切换弹窗
      TissueDialog: {
        visible: false, // 弹框是否显示
        width: '700px', // 宽度
        title: {
          reset: '组织切换'// 标题
        },
        type: 'reset', // 显示哪个标题
        // 按钮列表
        btList: [
          { label: '确定', type: 'primary', icon: '', event: 'save', loading: false },
          { label: '关闭', type: '', icon: '', event: 'close', loading: false }
        ]
      },
      // 组织切换表单
      TissueInfo: {
        ref: null,
        labelWidth: '25%',
        data: {
          oldTissueId: localStorage.loginTissueId,
          newTissueId: '',
        },
        list: [
          // { type: 'text', label: '登录名称：', value: 'name', disabled: true, style: 'width:80%' },
          { type: 'select', label: '当前组织：', value: 'oldTissueId',list:'tissueId', style: 'width:80%',disabled:true },
          { type: 'select', label: '新组织：', value: 'newTissueId',list:'tissueId', style: 'width:80%' }
        ],
        rules: {
        }
      },
      // 切换主题弹窗
      ColorDialog: {
        visible: false, // 弹框是否显示
        width: '530px', // 宽度
        title: {
          title: '切换主题'// 标题
        },
        type: 'title' // 显示哪个标题
      },
      // 切换主题列表数据
      ColorList: [
        // { style1: 'background: #367fa9', style2: 'background: #3c8dbc', style3: 'background: #2f4050', style4: 'background: #f3f3f4', font: 'color:#fff', desc: '蓝' },
        // { style1: 'background: #008d4c', style2: 'background: #00a65a', style3: 'background: #222d32', style4: 'background: #f4f5f7', font: 'color:#fff', desc: '绿' },
        // { style1: 'background: #555299', style2: 'background: #605ca8', style3: 'background: #222d32', style4: 'background: #f3f3f4', font: 'color:#fff', desc: '紫' },
        // { style1: 'background: #dd4b39', style2: 'background: #d73925', style3: 'background: #222d32', style4: 'background: #f3f3f4', font: 'color:#fff', desc: '红' },
        // { style1: 'background: #f39c12', style2: 'background: #e08e0b', style3: 'background: #222d32', style4: 'background: #f3f3f4', font: 'color:#fff', desc: '黄' },
        { style1: 'background: #367fa9', style2: 'background: #3c8dbc', style3: 'background: #f9fafc', style4: 'background: #f3f3f4', font: 'color:black', desc: '蓝灰' },
        { style1: 'background: #008d4c', style2: 'background: #00a65a', style3: 'background: #f9fafc', style4: 'background: #f3f3f4', font: 'color:black', desc: '绿灰' },
        { style1: 'background: #555299', style2: 'background: #605ca8', style3: 'background: #f9fafc', style4: 'background: #f3f3f4', font: 'color:black', desc: '紫灰' },
        { style1: 'background: #303133', style2: 'background: #666', style3: 'background: #f9fafc', style4: 'background: #f3f3f4', font: 'color:black', desc: '灰黑' },
        { style1: 'background: #f39c12', style2: 'background: #e08e0b', style3: 'background: #f9fafc', style4: 'background: #f3f3f4', font: 'color:black', desc: '黄灰' },
        { style1: 'background: #1097a5', style2: 'background: #19b2c1', style3: 'background: #f9fafc', style4: 'background: #f3f3f4', font: 'color:black', desc: '青灰' },
        // { style1: 'background: #367fa9', style2: 'background: #3c8dbc', style3: 'background: #0F2950', style4: 'background: #f3f3f4', font: 'color:#fff', desc: '蓝浅' },
        // { style1: 'background: #008d4c', style2: 'background: #00a65a', style3: 'background: #0F2950', style4: 'background: #f3f3f4', font: 'color:#fff', desc: '绿浅' }
      ]
    }
  },
  watch:{
    typeTime:{
      handler(n,o){
        // console.log(n,'1',o)
        this.typeWebS = this.typeD + this.typeTime
        // this.$emit('typeWebS', this.typeD)
      },
      deep:true// 深度监听父组件传过来对象变化
    },
    // 打开园区弹窗时重置过滤条件
    dropdownTissue (val) {
      if (val) {
        this.tissueFilterApplied = {}
        this.tissueFilterResult = {}
        this.fetchUserTissueList()
        this.$nextTick(() => {
          if (this.$refs.tissueFilter && this.$refs.tissueFilter.initParams) {
            this.$refs.tissueFilter.initParams()
          }
        })
      }
    }
  },
  mounted() {
    // 多浏览器标签同步园区切换：当其它页面修改 localStorage.loginTissueId 时，本页面刷新到新园区数据
    this._storageListener = (e) => {
      if (!e) return
      if (e.key !== 'loginTissueId') return
      const nextId = e.newValue
      if (nextId === undefined || nextId === null) return
      if (String(nextId) !== String(this.currentTissueId)) {
        location.reload()
      }
    }
    window.addEventListener('storage', this._storageListener)

    // 首次加载当前用户可切换的园区列表
    this.fetchUserTissueList({ silentError: true })
    this.notifyNeedUpdatePasswordAndJump()
  },
  beforeDestroy() {
    if (this._storageListener) {
      window.removeEventListener('storage', this._storageListener)
    }
  },
  methods: {
    notifyNeedUpdatePasswordAndJump () {
      const needOpen = localStorage.needOpenPasswordDialog === '1'
      const closeBt = this.PswDialog && Array.isArray(this.PswDialog.btList)
        ? this.PswDialog.btList.find(item => item && item.event === 'close')
        : null
      const logoutBt = this.PswDialog && Array.isArray(this.PswDialog.btList)
        ? this.PswDialog.btList.find(item => item && item.event === 'logout')
        : null
      const oldPasswordField = this.PswInfo && Array.isArray(this.PswInfo.list)
        ? this.PswInfo.list.find(item => item && item.value === 'oldPassword')
        : null
      this.PswDialog.lockClose = needOpen
      if (closeBt) {
        closeBt.show = !needOpen
      }
      if (logoutBt) {
        logoutBt.show = needOpen
      }
      if (oldPasswordField) {
        oldPasswordField.show = !needOpen
      }
      if (!needOpen) return
      this.$nextTick(() => {
        this.dialog('PswDialog')
      })
    },
    fetchUserTissueList (options = {}) {
      const silentError = !!options.silentError
      let username = ''
      try {
        username = JSON.parse(localStorage.personal || '{}').userName || ''
      } catch (e) {}
      if (!username) return Promise.resolve([])
      this.tissueListLoading = true
      return this.$api.user.getUserTissueList({ username }).then(res => {
        if (res.code === 0 && Array.isArray(res.data)) {
          this.TissueList = res.data
          this.syncWxMinProgramIdByTissueId(localStorage.loginTissueId)
          // 如果当前园区已不在可用列表中，自动切到第一个可用园区
          // 由于路由动态菜单是在 beforeEach 里根据 localStorage.loginTissueId 构建的，
          // 这里切换后需要再 reload 一次，确保菜单路由按新园区重建。
          const currentId = String(localStorage.loginTissueId || '')
          const hasCurrent = res.data.some(it => it && it.id !== undefined && it.id !== null && String(it.id) === currentId)
          if (!hasCurrent && res.data.length > 0) {
            const first = res.data[0]
            localStorage.loginTissueId = first && first.id !== undefined && first.id !== null ? String(first.id) : localStorage.loginTissueId
            localStorage.loginTissueName = (first && (first.tissueName || first.name)) ? String(first.tissueName || first.name) : localStorage.loginTissueName
            localStorage.wxMinProgramId = this.getWxMinProgramIdByTissue(first)
            localStorage.openEndDate = first && first.openEndDate ? String(first.openEndDate) : (localStorage.openEndDate || '')
            this.currentTissueId = localStorage.loginTissueId
            // 通知头部组件刷新“当前园区”显示（避免不触发整页 reload 导致旧值不更新）
            // 延后发出，确保 HeadBar 已完成 mounted 并注册监听
            setTimeout(() => window.dispatchEvent(new Event('tissue-changed')), 0)
            this.resetTabsAndBackHome()
          }
          return res.data
        }
        if (!silentError) {
          this.$message({ message: res.msg || '园区列表获取失败，请重试', type: 'error' })
        }
        return []
      }).catch(() => {
        if (!silentError) {
          this.$message({ message: '园区列表获取失败，请重试', type: 'error' })
        }
        return []
      }).finally(() => {
        this.tissueListLoading = false
      })
    },
    resetTabsAndBackHome () {
      // 切园区后先清空当前打开标签，避免停留在新园区无权限页面
      this.TabList = []
      this.$store.commit('updateActiveTab', '首页')
      this.$store.commit('RouterLoad', false)
      localStorage.logMenuName = ''
      localStorage.menuNameActive = '首页'
      localStorage.logMenuCode = ''
      localStorage.menuPath = ''
      // 带时间戳跳首页：避免同路由不触发守卫，确保重新拉取菜单接口
      this.$nextTick(() => {
        this.$router.replace({
          path: '/index',
          query: { tissueSwitchTs: String(Date.now()) }
        }).catch(() => {})
      })
    },
    getWxMinProgramIdByTissue (item) {
      if (!item) return ''
      if (item.wxMinProgramId === undefined || item.wxMinProgramId === null || item.wxMinProgramId === '') return ''
      return String(item.wxMinProgramId)
    },
    syncWxMinProgramIdByTissueId (tissueId) {
      const list = Array.isArray(this.TissueList) ? this.TissueList : []
      const targetId = tissueId !== undefined && tissueId !== null ? String(tissueId) : ''
      const matched = list.find(it => it && it.id !== undefined && it.id !== null && String(it.id) === targetId)
      localStorage.wxMinProgramId = this.getWxMinProgramIdByTissue(matched)
    },
    // 园区弹窗过滤回调
    handleTissueFilter (val, data) {
      switch (val) {
        case 'search':
          this.tissueFilterApplied = Object.assign({}, data)
          break
        case 'refresh':
          this.tissueFilterApplied = {}
          this.tissueFilterResult = {}
          this.$nextTick(() => {
            if (this.$refs.tissueFilter && this.$refs.tissueFilter.initParams) {
              this.$refs.tissueFilter.initParams()
            }
          })
          break
      }
    },
    //刷新
    reload: function () {
      this.isRou = false;
      this.$nextTick(function () {
        this.isRou = true;
      })
    },
    // 修改密码对话框按钮事件
    pswEvent (event) {
      const PswDialog = this.PswDialog
      const PswInfo = this.PswInfo
      switch (event) {
        case 'save':
          PswInfo.ref.validate((val) => {
            if (val) {
              const params = JSON.parse(JSON.stringify(this.PswInfo.data))
              const isForceChangePwd = this.PswDialog.lockClose || localStorage.needOpenPasswordDialog === '1'
              if(params.newPassword != params.surePass){
                  this.$message({ message: '两次密码不一致！', type: 'error' })
                  return
              }
              if (pwdPolicy.isPasswordStrengthWeak(pwdPolicy.evaluatePasswordStrength(params.newPassword))) {
                this.$message({ message: pwdPolicy.MESSAGE_REJECT_WEAK_PASSWORD_ON_CHANGE, type: 'warning' })
                return
              }
              let oldPass = params.oldPassword
              let newPass = params.newPassword
              if (isForceChangePwd) {
                params.oldPassword = localStorage.forceOldPasswordHash || ''
                if (!params.oldPassword) {
                  this.$message({ message: '未获取到旧密码凭据，请重新登录后再修改', type: 'error' })
                  return
                }
              } else {
                params.oldPassword = md5.hex(params.oldPassword)
              }
              params.newPassword = md5.hex(params.newPassword)
              PswDialog.btList[0].loading = true
              this.$api.user.password(params).then(res => {
                PswDialog.btList[0].loading = false
                if (res.code === 0) {
                  this.$message({ message: res.msg, type: 'success' })
                  PswDialog.visible = false
                  const rememberedUsername = localStorage.username || ''
                  localStorage.clear()
                  if (rememberedUsername) {
                    localStorage.username = rememberedUsername
                  }
                  localStorage.password = ''
                  localStorage.removeItem("token");
                  // localStorage.removeItem('client')
                  localStorage.removeItem('roleId')
                  localStorage.removeItem('userButtonList')//用户菜单按钮权限
                  localStorage.removeItem('companyType')//清除公司类型信息
                  this.$store.commit('RouterLoad', false)
                  this.$router.push('/login')
                  this.$store.commit('updateTabList', [])
                  this.$store.commit('updateActiveTab', '')
                } else {
                  params.oldPassword = oldPass
                  params.newPassword = newPass
                  this.$message({ message: res.msg, type: 'error' })
                }
              }, err => {
                console.log(err)
                PswDialog.btList[0].loading = false
              })
            }
          })
          break
        case 'close':
          if (this.PswDialog.lockClose) {
            this.$message({ message: '当前账号必须先修改密码，暂不允许关闭', type: 'warning' })
            return
          }
          PswDialog.visible = false
          this.PswInfo.ref.resetFields()
          break
        case 'logout':
          this.zhuxiao()
          break
      }
    },
    // 组织切换对话框按钮事件
    TissueEvent (event) {
      const TissueDialog = this.TissueDialog
      const TissueInfo = this.TissueInfo
      switch (event) {
        case 'save':
          const params = JSON.parse(JSON.stringify(this.TissueInfo.data))
          if(params.newTissueId == params.oldTissueId){
              this.$message({ message: '组织一样无需切换！', type: 'error' })
              return
          }
          // TissueDialog.btList[0].loading = true
          // this.$api.user.password(params).then(res => {
          //   TissueDialog.btList[0].loading = false
          //   if (res.code === 0) {
          //     this.$message({ message: res.msg, type: 'success' })
          //     TissueDialog.visible = false
          //   } else {
          //     this.$message({ message: res.msg, type: 'error' })
          //   }
          // }, err => {
          //   console.log(err)
          //   TissueDialog.btList[0].loading = false
          // })
          break
        case 'close':
          TissueDialog.visible = false
          break
      }
    },
    // 修改主题颜色
    changeColor (item) {
      this.$store.commit('logoColor', item.style1)
      this.$store.commit('headColor', item.style2)
      this.$store.commit('navColor', item.style3)
      this.$store.commit('fontColor', item.font)
    },
    // 个人中心
    geren () {
      this.$router.push('/index/personal')
      this.$store.commit('dropdownMenu', false)
    },
    tissueNumberDisplay (row) {
      if (!row) return '—'
      if (row.tissueCode !== undefined && row.tissueCode !== null && row.tissueCode !== '') return row.tissueCode
      return row.id
    },
    closeTissueSelectDialog () {
      this.$store.commit('dropdownTissue', false)
    },
    switchTissue (item) {// 园区切换
      this.$store.commit('dropdownTissue', false)
      if (!item || item.id === undefined || item.id === null) return
      if (String(localStorage.loginTissueId) === String(item.id)) {
        return
      }
      const name = item.tissueName || item.name || ''
      localStorage.loginTissueId = item.id
      localStorage.loginTissueName = name
      localStorage.openEndDate = item && item.openEndDate ? String(item.openEndDate) : (localStorage.openEndDate || '')
      try {
        const personal = JSON.parse(localStorage.personal || '{}')
        const username = personal && personal.userName ? String(personal.userName).trim() : ''
        if (username) {
          const map = JSON.parse(localStorage.lastLoginTissueMap || '{}')
          map[username] = { id: String(item.id), name: String(name || '') }
          localStorage.lastLoginTissueMap = JSON.stringify(map)
        }
      } catch (e) {}
      localStorage.wxMinProgramId = this.getWxMinProgramIdByTissue(item)
      this.currentTissueId = item.id
      // 通知头部组件同步“当前所在游乐场”展示（localStorage 非响应式）
      setTimeout(() => window.dispatchEvent(new Event('tissue-changed')), 0)
      this.resetTabsAndBackHome()
    },
    // 打开对话框
    dialog (dialog) {
      this[dialog].visible = true
    },
    // 注销
    zhuxiao () {
      this.$confirm('即将退出系统，是否继续？', '提示', {
        type: 'warning'
      }).then(() => {
        this.loding = true
        this.$store.commit('loding', true)
        this.$api.login.out({loginTissueId:localStorage.loginTissueId,username:JSON.parse(localStorage.personal).userName}).then(res => {
          this.loding = false
          this.$store.commit('loding', false)
          if (res.code === 0) {
            // if (localStorage.monitor == 'true') {
            //   let dvObj = JSON.parse(localStorage.deviceObject)
            //   let monitor = JSON.parse(localStorage.monitorData)
            //   let len = dvObj.session.length; //登出已经登录的全部设备
            //   for (let i = 0; i < len; i++) {
            //       if(dvObj.session[i] != 0) {
            //         axios.post(config.baseURL+'/RPC2', {method:'global.logout',session:dvObj.session[i]}, { headers: {
            //             "Content-Type": "application/json",
            //             "Self-TargetIP": monitor[i].deviceIp + ':80'
            //         }}).then(({ data: res }) => {
            //           if (res.result) {
            //             localStorage.monitor = 'false'
            //           }
            //         })
            //       }
            //   }
            //   // alert('监控中心:需先登出全部设备')
            //   // return
            // }
            const rememberedTissueMap = localStorage.lastLoginTissueMap || ''
            const rememberedUsername = localStorage.username || ''
            localStorage.clear()
            if (rememberedTissueMap) {
              localStorage.lastLoginTissueMap = rememberedTissueMap
            }
            if (rememberedUsername) {
              localStorage.username = rememberedUsername
            }
            localStorage.password = ''
            localStorage.languageName = this.language
            // console.log(localStorage);
            this.$message({ message: res.msg, type: 'success' })
            localStorage.removeItem("token");
            // localStorage.removeItem('client')
            localStorage.removeItem('roleId')
            localStorage.removeItem('userButtonList')//用户菜单按钮权限
            localStorage.removeItem('companyType')//清除公司类型信息
            this.$store.commit('RouterLoad', false)
            this.$router.push('/login')
            this.$store.commit('updateTabList', [])
            this.$store.commit('updateActiveTab', '')
          } else {
            this.$message({ message: res.msg, type: 'error' })
          }
        }, err => {
          console.log(err)
          localStorage.removeItem('token')
          localStorage.removeItem('roleId')
          localStorage.removeItem('companyType')//清除公司类型信息
          this.$router.push('/login')
          this.loding = false
          this.$store.commit('loding', false)
        })
      })
    },
    // 刷新
    refresh () {
      let arr = JSON.parse(JSON.stringify(this.TabList))
      for (let i in arr) {
        if (arr[i].name === this.$route.name) {
          arr[i].keepAlive = '0' + arr[i].keepAlive
        }
      }
      // 将要刷新的路由keepAlive的值变成空
      this.TabList = arr
      this.$router.replace({
        path: '/index/refresh',
        query: {
        }
      })
    }
  }
}
</script>

<style lang="stylus" scoped>
.Maincontent>>>.el-form-item__error
  top 30%
  right 25%
  left 50%
  text-align right
.Maincontent>>>.el-form--inline .el-form-item__error
  top 30%
  right 25px
  text-align right

.ThemeColor >>>.el-dialog__body
  padding 8px
  background #f3f3f4

/* left 由全局 index.css：calc(间距*2 + 侧栏宽) */
.position-left,
.position-collapse-left
  transition left 0.3s ease

.color_item
  width 33.333%
  float left
  padding 5px
  box-sizing border-box
  .ThemeItem
    box-shadow 0 0 5px rgba(86, 96, 117, 0.3)
    border 1px solid #fff
    box-sizing border-box
  .ThemeItem:hover
    border 1px solid red

.foot
  position absolute
  bottom 0
  left 0
  right 0
  box-sizing border-box
  padding 10px 20px
  background #fff
  font-size 13px
  text-align center
  border-top 1px solid #ebeef5
  color #909399
  a
    color #909399
    text-decoration none
    margin-left 8px
    &:hover
      color #409eff
      text-decoration underline

.tissue-select-dialog-footer
  text-align center

.tissue-select-table>>>.el-table__body tr
  cursor pointer

// 让“选择园区”弹窗表格更紧凑：减少表头高度，避免下面数据被顶下去
.tissue-select-table>>>.el-table__header-wrapper th
  padding 8px 0 !important
  line-height 20px !important

.tissue-select-table>>>.el-table__body td
  padding 6px 0 !important
  line-height 20px !important

/* 修改密码弹窗 slot：整体左对齐，避免与表单项错位 */
.psw-password-dialog-slot
  text-align left
  width 100%
  box-sizing border-box

.password-strength-panel
  display flex
  align-items center
  margin 6px 0 2px
  width 100%
  box-sizing border-box
  text-align left
  .label
    width 25%
    flex 0 0 25%
    color #606266
    font-size 13px
    text-align right
    padding-right 12px
    box-sizing border-box
  .strength-content
    flex 1
    min-width 0
    display flex
    align-items center
    gap 10px
  .strength-bar
    width 180px
    height 8px
    border-radius 999px
    background #ebeef5
    overflow hidden
  .strength-fill
    display block
    height 100%
    width 0
    transition width 0.25s ease
    background #c0c4cc
    &.weak
      background #f56c6c
    &.medium
      background #e6a23c
    &.strong
      background #67c23a
  .strength-text
    min-width 32px
    font-size 13px
    color #909399
    &.weak
      color #f56c6c
    &.medium
      color #e6a23c
    &.strong
      color #67c23a

.password-strength-tip
  margin 0 0 10px
  padding-left calc(25% + 12px)
  font-size 12px
  color #909399
  text-align left
  width 100%
  box-sizing border-box

.password-policy-panel
  margin 8px 0 12px
  padding 8px 12px 8px calc(25% + 12px)
  border-radius 4px
  background #fafafa
  font-size 13px
  line-height 22px
  text-align left
  width 100%
  box-sizing border-box
.password-policy-row
  display flex
  align-items flex-start
  justify-content flex-start
  margin-bottom 6px
  &:last-child
    margin-bottom 0
  .password-policy-text
    flex 1
    text-align left
    color #606266
  &.status-ok .password-policy-text
    color #606266
  &.status-fail .password-policy-text
    color #f56c6c
  &.status-pending .password-policy-text
    color #909399
.password-policy-icon
  margin-right 8px
  margin-top 2px
  font-size 15px
  flex-shrink 0
.password-policy-icon--ok
  color #67c23a
.password-policy-icon--fail
  color #f56c6c
.password-policy-dot
  display inline-block
  width 15px
  margin-right 8px
  margin-top 2px
  flex-shrink 0
  text-align center
  color #c0c4cc
  font-size 12px
  line-height 15px
  &:before
    content '\2022'

.force-password-tip
  margin 0 0 12px
  padding 10px 12px
  border 1px solid #f5dab1
  border-radius 4px
  background #fff7e6
  color #ad6800
  font-size 13px
  line-height 20px
  text-align left
  width 100%
  box-sizing border-box
</style>

<!-- append-to-body 的弹窗不在 .Maincontent 下，单独写非 scoped 样式 -->
<style lang="stylus">
.tissue-merchant-select-dialog.el-dialog .el-dialog__body
  padding 12px 20px 8px
</style>


// WEBPACK FOOTER //
// src/views/MainContent/MainContent.vue